import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { FailIcon } from 'assets/icons';
import { Container } from './styles';

const ModalGeneralFailed = ({
  isOpen,
  setIsOpen,
  amount,
  cardNumber,
  loading,
  errorType,
  errorMessage,
  retryFunction,
  cancelFunction,
  type
}) => {

  const getTitle = (type) => {
    let title;
    switch (type) {
      case "reset-wifi":
        title = "Failed to Reset Wi-Fi Access";
        break;
      case "invalidate-wifi":
        title = "Failed to Invalidate Wi-Fi Access";
        break;
      case "checkInPayment":
        title = "Try Another Terminal";
        break;
      case "passport-scan":
        title = "Document Not Detected";
        break;
    default:
        title = "";
    }
    return title;
  }
  
  const getMessage = (type, amount, cardNumber) => {
    let message;
    const formattedAmount = Number(amount).toFixed(2);
    const last4 = cardNumber?.slice(-4);

    switch (type) {
      case "reset-wifi":
        message = "We were unable to reset Wi-Fi access. Please try again.";
        break;
      case "invalidate-wifi":
        message = "We were unable to invalidate Wi-Fi access. Please try again.";
        break;
      case "checkInPayment":
        message = errorType;
        break;
      case "passport-scan":
        message = "Please make sure the documents are placed properly on the scanner and try again.";
        break;
      case "onlyAddChargeToBill":
        message = `Unable to add charge of $${formattedAmount} to the bill.`;
        break;
      case "retry":
        message = "Transaction retry failed.";
        break;
      case "coupon":
        message = "Invalid coupon code entered. Please check the code and try again.";
        break;

      case "void":
        message = `Unable to void the $${formattedAmount} transaction of the card ending in ${last4}.`;
        break;

      case "settlement":
        message = "There was an issue triggering the payment process. Please try again later.";
        break;

      case "createStaff":
        message = "Unable to create staff.";
        break;

      default:
        message = `Unable to apply a ${type} of $${formattedAmount} to the card ending in ${last4}.`;
    }

    return message;
  }

  const title = getTitle(type);
  const message = getMessage(type, amount, cardNumber);

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <FailIcon />
        {title && <div className="title">{title}</div>}
        <div className="text">{message}</div>
        {errorMessage && <div className="error">{errorMessage}</div>}
        <div className="buttonContainer">
          <Button
            danger
            onClick={() => {
              cancelFunction && cancelFunction();
              setIsOpen(false)
            }}
            additionalstyle={`
              width: 79px;
              margin-right: 16px;
            `}
          >
            Cancel
          </Button>
          <Button
            success
            onClick={retryFunction}
            data-loading={loading}
            additionalstyle={`
              width: 72px;
            `}
          >
            {loading ? null : "Retry"}
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalGeneralFailed;
